import axios from 'axios';
import { apiPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { GetStatisticsByDateApiRQData, GetStatisticsByDateApiResponse } from 'models/CL/CLApiTypes';

class StatisticsApi {
    async getStatisticsByDate(rqData: GetStatisticsByDateApiRQData, token: string): Promise<GetStatisticsByDateApiResponse> {
        try {
            const response = await axios.post(apiPaths.CLGetStatisticsByDate, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const CLStatisticsApi = new StatisticsApi();
